<style lang="less" scoped>
  .iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
</style>

<template>
  <page-container class="elearning"
    :title="$t('E-Learning')"
    cover>
    <!-- <iframe v-if="url" class="iframe" :src="url" /> -->
  </page-container>
</template>

<script>
import PageContainer from '../../components/PageContainer'

export default {
  components: { PageContainer },
  name: 'elearning',
  data () {
    return {
      // url: '',
      from: null
    }
  },
  methods: {
    getElearningUrl () {
      return this.$apis.home.getElearningUrl(
        loading => (this.elearlingLoading = loading)
      ).then(res => {
        // this.url = res
        if (res) window.open(res, '_self')
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.from = from
    })
  },
  mounted () {
    if (this.from && this.from.name === 'home') {
      this.getElearningUrl()
    } else {
      this.$router.replace({ name: 'home' })
    }
  }
}
</script>
